/* =====================================================
   SOFS — Explorador de fotos en la tarjeta de producto
   Flechas a los lados (solo desktop) para ver las primeras 4 fotos.

   Cómo se reparte el trabajo con el tema:
   - Sin foto elegida (pos 0) esta capa es transparente: manda el tema, que
     muestra la foto 1 en reposo y hace el barrido al pasar el mouse.
   - Al usar las flechas la capa se pone encima con la foto pedida. La primera
     flecha arranca desde la foto que dejó el barrido (la manda el Liquid en
     data-sofs-cg-hover-pos, normalmente la 2).
   - Al salir de la tarjeta se suelta la capa y vuelve la foto 1.

   Dos cosas que hay que respetar o se ve un parpadeo:
   1. La foto nueva se pinta SOLO cuando terminó de bajar. Mientras baja se
      queda la que está: nunca un hueco en blanco.
   2. La foto 1 de esta capa reusa el srcset que ya cargó el tema, así el
      navegador la saca del caché en vez de bajarla otra vez.

   Ojo: el archivo puede quedar cargado dos veces (tema + inyección por AJAX
   de la compra rápida), por eso la bandera de arriba.
   ===================================================== */
(function () {
  if (window.__sofsCardGalleryReady) return;
  window.__sofsCardGalleryReady = true;

  var DESKTOP = '(min-width: 1024px) and (hover: hover)';
  var mq = window.matchMedia(DESKTOP);

  function closest(node, sel) {
    if (!node || !node.closest) return null;
    return node.closest(sel);
  }

  function slidesOf(gallery) {
    return gallery.querySelectorAll('[data-sofs-cg-slide]');
  }

  function hydrateSlide(gallery, slide, urgente) {
    var img = slide.querySelector('img[data-src]');
    if (!img) return;

    // La foto 1 ya está en pantalla (la dibuja el tema): copiarle el srcset
    // para que salga del caché y no cueste una descarga nueva.
    if (slide.hasAttribute('data-sofs-cg-featured')) {
      var card = closest(gallery, '[data-product-block]');
      var themeImg = card && card.querySelector('[data-main-image] img, [data-product-image] img');
      var themeSrc = themeImg && (themeImg.currentSrc || themeImg.getAttribute('src'));
      if (themeSrc) {
        var ss = themeImg.getAttribute('srcset');
        var sz = themeImg.getAttribute('sizes');
        if (ss) img.setAttribute('srcset', ss);
        if (sz) img.setAttribute('sizes', sz);
        img.setAttribute('src', themeSrc);
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        return;
      }
    }

    if (urgente) img.setAttribute('fetchpriority', 'high');
    var srcset = img.getAttribute('data-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  // Las fotos se bajan EN FILA, una detras de otra, en el orden en que el cliente
  // las va a pedir. Antes arrancaban todas juntas y se peleaban el ancho de banda:
  // con 8 fotos, el primer clic tardaba mas de un segundo en mostrar algo.
  function hydrateCard(gallery) {
    if (gallery.getAttribute('data-sofs-cg-ready')) return;
    gallery.setAttribute('data-sofs-cg-ready', '1');
    var slides = slidesOf(gallery);
    if (!slides.length) return;
    hydrateSlide(gallery, slides[0]); // esta sale del cache del tema: gratis
    var i = 1;
    function siguiente() {
      while (i < slides.length && !slides[i].querySelector('img[data-src]')) i++;
      if (i >= slides.length) return;
      var slide = slides[i++];
      hydrateSlide(gallery, slide);
      var img = slide.querySelector('img');
      if (!img || img.complete) { siguiente(); return; }
      img.addEventListener('load', siguiente, { once: true });
      img.addEventListener('error', siguiente, { once: true });
    }
    siguiente();
  }

  function paint(slides, pos, gallery) {
    for (var i = 0; i < slides.length; i++) {
      if (pos !== 0 && i === pos - 1) slides[i].classList.add('is-active');
      else { slides[i].classList.remove('is-active'); slides[i].style.zIndex = ''; }
    }
    // Cual quedo realmente a la vista (la que ya cargo), para no apagarla mientras
    // baja la siguiente.
    if (gallery) gallery.setAttribute('data-sofs-cg-vista', pos);
  }

  // pos: 0 = sin foto elegida (manda el tema) · 1..N = foto N
  function show(gallery, pos) {
    var slides = slidesOf(gallery);
    var total = slides.length;
    if (!total) return;
    if (pos !== 0) pos = ((((pos - 1) % total) + total) % total) + 1;
    gallery.setAttribute('data-sofs-cg-pos', pos);

    if (pos === 0) {
      paint(slides, 0, gallery);
      return;
    }

    var slide = slides[pos - 1];
    hydrateSlide(gallery, slide, true); // la pedida se adelanta en la fila
    var img = slide.querySelector('img');

    // Si la foto todavía está bajando, se deja la actual hasta que esté lista, pero
    // con tope: pasado ese tiempo se pinta igual (debajo esta la foto del tema, no
    // queda un hueco) para que el clic nunca se sienta muerto.
    if (img && !img.complete) {
      // La foto pedida se pone ENCIMA de la actual ya mismo, todavia transparente
      // (la imagen no ha bajado). Mientras tanto se sigue viendo la foto anterior:
      // nunca un hueco, y sin volver un instante a la del barrido del tema.
      var vista = parseInt(gallery.getAttribute('data-sofs-cg-vista') || '0', 10);
      var todas = slidesOf(gallery);
      for (var q = 0; q < todas.length; q++) {
        if (q === vista - 1) continue; // la que se esta viendo se queda debajo
        todas[q].classList.remove('is-active');
        todas[q].style.zIndex = '';
      }
      slide.style.zIndex = '1';
      slide.classList.add('is-active');
      var pintado = false;
      var pintar = function () {
        if (pintado) return;
        pintado = true;
        slide.style.zIndex = '';
        if (parseInt(gallery.getAttribute('data-sofs-cg-pos') || '0', 10) === pos) {
          paint(slidesOf(gallery), pos, gallery);
        }
      };
      img.addEventListener('load', pintar, { once: true });
      img.addEventListener('error', pintar, { once: true });
      // Puede haber terminado de bajar justo entre el chequeo y el oyente: en ese caso
      // el evento 'load' ya paso y no vuelve, y quedaban dos fotos encendidas a la vez.
      if (img.complete) pintar();
      setTimeout(pintar, 2000); // red de seguridad
      return;
    }

    paint(slides, pos, gallery);
  }

  function galleryInCard(card) {
    return card ? card.querySelector('[data-sofs-card-gallery]') : null;
  }

  document.addEventListener(
    'pointerover',
    function (e) {
      if (!mq.matches) return;
      var gallery = galleryInCard(closest(e.target, '[data-product-block]'));
      if (gallery) hydrateCard(gallery);
    },
    true
  );

  // Salir de la tarjeta: soltar la capa y volver a la foto 1.
  document.addEventListener(
    'pointerout',
    function (e) {
      if (!mq.matches) return;
      var card = closest(e.target, '[data-product-block]');
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return; // sigue dentro
      var gallery = galleryInCard(card);
      if (gallery) show(gallery, 0);
    },
    true
  );

  // Red de seguridad: si la tarjeta dejó de estar bajo el mouse sin que llegara
  // el pointerout (pasa al hacer scroll sin mover el mouse), soltar la capa.
  window.addEventListener(
    'scroll',
    function () {
      if (!mq.matches) return;
      var abiertas = document.querySelectorAll('[data-sofs-card-gallery][data-sofs-cg-pos]:not([data-sofs-cg-pos="0"])');
      for (var i = 0; i < abiertas.length; i++) {
        var card = closest(abiertas[i], '[data-product-block]');
        if (card && !card.matches(':hover')) show(abiertas[i], 0);
      }
    },
    { passive: true }
  );

  // =====================================================
  // CELULAR — la tarjeta deja ver todas las fotos deslizando con el dedo, con una
  // barrita abajo que indica en cual va. Sin flechas. Un toque abre el producto.
  //
  // Bytes: la foto 1 se reusa del cache del tema y las demas solo se bajan cuando
  // el cliente toca la tarjeta, igual que en computador.
  // =====================================================
  var mqMovil = window.matchMedia('(max-width: 1023px), (hover: none)');

  // La foto entra desvanecida cuando termina de bajar (nunca de golpe).
  function marcarLista(slide) {
    var img = slide && slide.querySelector('img');
    if (!img) return;
    if (img.complete && img.naturalWidth) { img.classList.add('sofs-cg-lista'); return; }
    img.addEventListener('load', function () { img.classList.add('sofs-cg-lista'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('sofs-cg-lista'); }, { once: true });
  }

  function initMovil(gallery) {
    if (gallery.getAttribute('data-sofs-cg-movil') === '1') return;
    var cinta = gallery.querySelector('.sofs-card-gallery__slides');
    var slides = slidesOf(gallery);
    if (!cinta || slides.length < 2) return;
    gallery.setAttribute('data-sofs-cg-movil', '1');

    // En celular son 4 fotos como maximo: las demas se apagan (solo en celular, por CSS).
    var MAX_MOVIL = 4;
    var visibles = [];
    for (var v = 0; v < slides.length; v++) {
      if (v < MAX_MOVIL) visibles.push(slides[v]);
      else slides[v].classList.add('sofs-cg-fuera');
    }
    slides = visibles;

    hydrateSlide(gallery, slides[0]);
    marcarLista(slides[0]);

    var barra = document.createElement('div');
    barra.className = 'sofs-cg-bar';
    for (var i = 0; i < slides.length; i++) {
      var t = document.createElement('span');
      if (i === 0) t.className = 'is-on';
      barra.appendChild(t);
    }
    gallery.appendChild(barra);

    // La barrita va DEBAJO de la tira de tallas.
    function ubicarBarra() {
      var card = closest(gallery, '[data-product-block]');
      var tallas = card && card.querySelector('.product-grid-item__sizes__list, .product-grid-item__sizes');
      if (!tallas) return;
      var rg = gallery.getBoundingClientRect(), rt = tallas.getBoundingClientRect();
      if (!rg.height || !rt.height) return;
      barra.style.bottom = Math.max(3, Math.round(rg.bottom - rt.bottom) - 4) + 'px';
    }
    ubicarBarra();
    window.addEventListener('resize', ubicarBarra);
    setTimeout(ubicarBarra, 900);

    var hidratado = false;
    function hidratarTodo() {
      if (hidratado) return;
      hidratado = true;
      // En fila, no todas de golpe: la 2 primero, que es la que sigue.
      var k = 1;
      (function siguiente() {
        while (k < slides.length && !slides[k].querySelector('img[data-src]')) { marcarLista(slides[k]); k++; }
        if (k >= slides.length) return;
        var slide = slides[k++];
        hydrateSlide(gallery, slide);
        marcarLista(slide);
        var img = slide.querySelector('img');
        if (!img || img.complete) { siguiente(); return; }
        img.addEventListener('load', siguiente, { once: true });
        img.addEventListener('error', siguiente, { once: true });
      })();
    }

    // La foto 2 se adelanta apenas la tarjeta asoma en pantalla: asi el primer
    // deslizada no cae en una foto vacia. Las demas siguen esperando al primer toque.
    if (window.IntersectionObserver && slides[1]) {
      var ojo = new IntersectionObserver(function (ents) {
        for (var n = 0; n < ents.length; n++) {
          if (!ents[n].isIntersecting) continue;
          hydrateSlide(gallery, slides[1]);
          marcarLista(slides[1]);
          ojo.disconnect();
        }
      }, { rootMargin: '300px 0px' });
      ojo.observe(gallery);
    }

    function pintarBarra() {
      var ancho = cinta.clientWidth || 1;
      var i = Math.round(cinta.scrollLeft / ancho);
      var ps = barra.children;
      for (var k = 0; k < ps.length; k++) ps[k].className = (k === i ? 'is-on' : '');
    }

    cinta.addEventListener('touchstart', hidratarTodo, { passive: true });

    // Volver a la foto 1 cuando el cliente deja de interactuar (o cuando la tarjeta
    // se va de la pantalla). Sin animacion si ya no se ve: que no se note el salto.
    var REPOSO = 3000;
    var relojReposo = null;
    function alaPrimera(suave) {
      if (cinta.scrollLeft <= 2) return;
      if (suave && cinta.scrollTo) cinta.scrollTo({ left: 0, behavior: 'smooth' });
      else cinta.scrollLeft = 0;
    }
    function contarReposo() {
      if (relojReposo) clearTimeout(relojReposo);
      relojReposo = setTimeout(function () { alaPrimera(true); }, REPOSO);
    }

    // De la ultima foto, otro deslizada hacia adelante vuelve a la primera.
    var tx = 0, ty = 0;
    cinta.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; tx = t.clientX; ty = t.clientY;
      if (relojReposo) clearTimeout(relojReposo);
    }, { passive: true });
    cinta.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      var dx = t.clientX - tx, dy = t.clientY - ty;
      var tope = cinta.scrollWidth - cinta.clientWidth;
      // Da la vuelta para los dos lados: de la ultima a la primera y de la primera a la ultima.
      if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
        var destino = null;
        if (dx < 0 && cinta.scrollLeft >= tope - 2) destino = 0;
        else if (dx > 0 && cinta.scrollLeft <= 2) destino = tope;
        if (destino !== null) {
          if (cinta.scrollTo) cinta.scrollTo({ left: destino, behavior: 'smooth' });
          else cinta.scrollLeft = destino;
        }
      }
      contarReposo();
    }, { passive: true });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) if (!ents[i].isIntersecting) alaPrimera(false);
      }, { threshold: 0 }).observe(gallery);
    }
    cinta.addEventListener('scroll', function () { hidratarTodo(); pintarBarra(); contarReposo(); }, { passive: true });

    // Un toque sin arrastre abre el producto; si arrastro, no.
    var x0 = 0, y0 = 0, movido = false;
    cinta.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; movido = false; hidratarTodo(); });
    cinta.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - x0) > 6 || Math.abs(e.clientY - y0) > 6) movido = true;
    });
    cinta.addEventListener('click', function (e) {
      if (movido) { e.preventDefault(); e.stopPropagation(); return; }
      var card = closest(gallery, '[data-product-block]');
      var a = card && card.querySelector('a[href]');
      if (a) { e.preventDefault(); a.click(); }
    });
  }

  function barrerMovil() {
    if (!mqMovil.matches) return;
    // En el home la tarjeta solo cambia con las flechas: nada de tira deslizable.
    if (document.body && document.body.classList.contains('template-index')) return;
    var gs = document.querySelectorAll('[data-sofs-card-gallery]');
    for (var i = 0; i < gs.length; i++) initMovil(gs[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', barrerMovil);
  else barrerMovil();
  setTimeout(barrerMovil, 800);
  setTimeout(barrerMovil, 2500);
  // Tarjetas que llegan despues (paginacion, filtros, compra rapida).
  if (window.MutationObserver) {
    var pendiente = null;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = setTimeout(function () { pendiente = null; barrerMovil(); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Sin mouse (celular) no existe el "salir de la tarjeta": a los 3s sin tocar nada,
  // o si la tarjeta se va de la pantalla, vuelve sola a la foto principal.
  var REPOSO_FLECHAS = 2000;
  function programarVuelta(gallery) {
    if (mq.matches) return; // en computador manda el hover
    if (gallery.__sofsReloj) clearTimeout(gallery.__sofsReloj);
    gallery.__sofsReloj = setTimeout(function () { show(gallery, 0); }, REPOSO_FLECHAS);
    if (!gallery.__sofsOjo && window.IntersectionObserver) {
      gallery.__sofsOjo = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          if (ents[i].isIntersecting) continue;
          if (gallery.__sofsReloj) clearTimeout(gallery.__sofsReloj);
          show(gallery, 0);
        }
      }, { threshold: 0 });
      gallery.__sofsOjo.observe(gallery);
    }
  }

  // Flechas. En captura para que nunca dispare el enlace de la tarjeta.
  document.addEventListener(
    'click',
    function (e) {
      var btn = closest(e.target, '[data-sofs-cg-prev], [data-sofs-cg-next]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var gallery = closest(btn, '[data-sofs-card-gallery]');
      if (!gallery) return;
      hydrateCard(gallery);
      var pos = parseInt(gallery.getAttribute('data-sofs-cg-pos') || '0', 10) || 0;
      if (pos === 0) {
        // Veníamos del barrido del tema: seguir desde la foto que dejó.
        pos = parseInt(gallery.getAttribute('data-sofs-cg-hover-pos') || '2', 10) || 2;
      }
      var total = slidesOf(gallery).length;
      var destino = btn.hasAttribute('data-sofs-cg-next') ? pos + 1 : pos - 1;
      if (destino === 0) destino = total; // atras desde la foto 1 → la ultima
      show(gallery, destino);
      programarVuelta(gallery);
    },
    true
  );
})();
